import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import {
  CreateSkillRequestBody,
  CreateSkillsRequestBody,
} from "@src/types/skill-types";

export type CreateSkillPayload = CreateSkillRequestBody;

export interface CreateSkillApiResponseItem {
  skill_type?: string;
  machine_id?: string;
  operation_id: string | null;
  operation_type?: string;
}

export type CreateSkillApiResponse =
  | CreateSkillApiResponseItem
  | CreateSkillApiResponseItem[];

export const postCreateSkill = async (
  namespace: string,
  machineId: string,
  body: CreateSkillsRequestBody,
) => {
  const url = clientConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.post<CreateSkillApiResponse>(
      `${url}/api/v4/ns/${namespace}/machines/${machineId}/skills`,
      body,
      { headers },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw err;
    } else {
      throw new Error(
        "An unexpected error occurred while installing the skill.",
      );
    }
  }
};
